

<template>
	<div class="delivery-cell" style="height:100px;width:100px;background:white;border-radius: 5px;">
		<div class="flexcenter" style="flex-direction:column;justify-content: space-between;text-align:center;height:100%;">
			<div class="icon">
				<Icon :fileName="this.fileName" style="flex-grow:0;height:40px;width:auto;margin-top:15px;" />
			</div>

			<b style="font-size:80%;color:grey;">{{this.title}}</b>
			<span style="font-size:70%;color:grey;margin-bottom: 5px;">{{ this.subtitle }}</span>
		</div>
	</div>
</template>
<script>

export default {
	name: "DeliveryCell",
	props: {
		fileName:String,
		title:String,
		subtitle: String
	},
}
</script>

<style scoped></style>